var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "Polaris-Box Polaris-Box--printHidden" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "Polaris-Button Polaris-Button--primary",
                            attrs: { type: "button", disabled: _vm.isLoading },
                            on: { click: _vm.refreshCurrentPage }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "Polaris-Button__Content" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "Polaris-Button__Text" },
                                  [
                                    _vm._v("Refresh"),
                                    _vm.isLoading
                                      ? _c("span", [_vm._v("ing")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-7xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _vm.messageLogs.docs && _vm.messageLogs.docs.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                              },
                              [
                                _c("table", { staticClass: "min-w-full" }, [
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      { staticClass: "hidden md:table-row" },
                                      [
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                          },
                                          [_vm._v(" Subscriber Id ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                          },
                                          [_vm._v(" Message Status ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                          },
                                          [_vm._v(" Message Type ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                          },
                                          [_vm._v(" DATE ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass:
                                              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                          },
                                          [_vm._v(" Message ")]
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "tbody",
                                    { staticClass: "bg-white" },
                                    _vm._l(_vm.messageLogs.docs, function(log) {
                                      return _c(
                                        "tr",
                                        {
                                          key: log.id,
                                          staticClass:
                                            "grid grid-cols-2 grid-flow-row md:table-row"
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(log.subscriberId) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(log.messageStatus) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(log.type) + " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("dateFilter")(
                                                      log.createdAt
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap w-96"
                                            },
                                            [
                                              _c("NotificationPreview", {
                                                attrs: {
                                                  title: log.title,
                                                  description: log.description,
                                                  hideAction: true
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]),
                                _c("Pagination", {
                                  attrs: { page: _vm.messageLogs },
                                  on: { pageChanged: _vm.loadPage }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isLoading &&
                        _vm.messageLogs.docs &&
                        _vm.messageLogs.docs.length === 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                              },
                              [
                                _vm._v(
                                  " You don't have any message logs right now. We will be listing them here as soon as we sent a message. "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }